module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p7-b8b4474646d6294795e7b2d6f51ae896.png";